<template>
  <div class="preview-box">
    <template v-if="form && form.project_name">
      <Divider title="项目基础信息"></Divider>
      <LabelRow label="项目名称：">{{ form.project_name }}</LabelRow>
      <LabelRow label="应用平台：">{{ PLATFORM_LIST.find((item) => item.value === form.ch_platform_id).label }}</LabelRow>
      <LabelRow label="应用：">{{ form.game.name }}</LabelRow>
      <LabelRow label="回调开关：">
        <el-switch disabled v-model="form.callback_switch" :active-value="1" :inactive-value="0"> </el-switch>
      </LabelRow>

      <Divider title="营销目标及场景"></Divider>
      <LabelRow label="推广目的：">{{ LANDING_TYPE_LIST.find((item) => item.value === form.landing_type).label }}</LabelRow>
      <LabelRow label="子目的：" v-if="form.landing_type === LANDING_TYPE.APP">
        {{ APP_PROMOTION_TYPE_LIST.find((item) => item.value === form.app_promotion_type).label }}
      </LabelRow>

      <template v-if="form.landing_type === LANDING_TYPE.MICRO_GAME">
        <LabelRow label="投放内容：">
          {{ form.micro_promotion_type === 'WECHAT_GAME' ? '微信小游戏' : '字节小游戏' }}
        </LabelRow>

        <LabelRow label="小游戏资产ID：">
          {{ form.micro_app_instance_id }}
        </LabelRow>
      </template>

      <template v-if="!isV3 && starTaskNames">
        <LabelRow label="关联星广联投任务：">{{ starTaskNames }}</LabelRow>
        <LabelRow v-if="!isV3" label="自动优选素材：">
          <el-switch disabled v-model="form.star_auto_material_addition_switch" active-value="ON" inactive-value="OFF"> </el-switch>
        </LabelRow>
      </template>
      <LabelRow label="计划类型：">
        <span v-if="isSearch"> 搜索计划</span>
        <span v-else>通投计划</span>
      </LabelRow>
      <LabelRow label="投放模式：" v-if="isSearch && !isV3">
        {{ DELIVERY_TYPE_LIST.find((item) => item.value === form.delivery_type).label }}
      </LabelRow>
      <LabelRow label="投放模式：" v-else>{{ DELIVERY_MODE_LIST.find((item) => item.value === form.delivery_mode).label }}</LabelRow>
      <LabelRow label="营销场景：">{{ MARKETING_GOAL_LIST.find((item) => item.value === form.marketing_goal).label }}</LabelRow>
      <LabelRow v-if="isV3" label="定向设置：">{{ audienceTypeLabel }}</LabelRow>
      <LabelRow label="蓝海流量投放：" v-if="isBlueFlowEnable">
        <span>启用</span>
      </LabelRow>

      <template v-if="isAll">
        <Divider title="搜索快投"></Divider>
        <LabelRow label="搜索快投开关：">
          <el-switch :value="form.keywordSwitch" :active-value="1" :inactive-value="0"></el-switch>
        </LabelRow>
      </template>
      <template v-if="form.keywordSwitch">
        <LabelRow label="关键词：">{{ form.keywordsDesc }}</LabelRow>
        <LabelRow label="出价系数：">{{ form.search_bid_ratio }}</LabelRow>
        <LabelRow label="定向扩展：">{{ AUDIENCE_EXTEND_LIST.find((item) => item.value === form.audience_extend).label }}</LabelRow>
      </template>

      <Divider title="排期和出价设置"></Divider>
      <LabelRow label="日预算：">
        <span v-if="form.delivery_setting.budget_mode === BUDGET_MODE.INFINITE">不限</span>
        <span v-if="form.delivery_setting.budget_mode === BUDGET_MODE.DAY">{{ form.delivery_setting.budget }}</span>
      </LabelRow>

      <LabelRow label="投放日期：" v-if="form.delivery_setting.schedule_type === SCHEDULE_TYPE.FROM_NOW"> 长期投放 </LabelRow>
      <LabelRow label="投放日期：" v-if="form.delivery_setting.schedule_type === SCHEDULE_TYPE.START_END">
        <span>{{ form.delivery_setting.date_range[0] }}</span>
        <span> ~ </span>
        <span>{{ form.delivery_setting.date_range[1] }}</span>
      </LabelRow>

      <LabelRow label="投放时段：" v-if="form.delivery_setting.schedule_time_type === SCHEDULE_TIME_TYPE.RANGE">
        <ReadableWeekdays :list="form.delivery_setting.readableWeekdays"></ReadableWeekdays>
      </LabelRow>

      <LabelRow label="竞价策略：">{{ BID_TYPE_LIST.find((item) => item.value === form.delivery_setting.bid_type).label }}</LabelRow>
      <LabelRow label="潜力探索：" v-if="form.delivery_setting.bid_type === BID_TYPE.CUSTOM">
        <span v-if="form.delivery_setting.bid_type_upgrade === BID_TYPE.CUSTOM">常规版</span>
        <span v-if="form.delivery_setting.bid_type_upgrade === BID_TYPE.EXPLORE_UPGRADE">升级版</span>
      </LabelRow>
      <LabelRow label="计费方式：">oCPM</LabelRow>

      <LabelRow label="优化目标：">
        {{ EXTERNAL_ACTION_LIST.find((item) => item.value === form.delivery_setting.optimize_goal.external_action).label }}
      </LabelRow>

      <LabelRow label="深度优化方式：">
        {{ DEEP_BID_TYPE_LIST.find((item) => item.value === form.delivery_setting.optimize_goal.deep_bid_type).label }}
      </LabelRow>

      <LabelRow label="深度优化目标：" v-if="adDeepBidVisible">
        {{ DEEP_EXTERNAL_ACTION_LIST.find((item) => item.value === form.delivery_setting.optimize_goal.deep_external_action).label }}
      </LabelRow>

      <template v-if="isFirstRoiGoal">
        <LabelRow label="首日+7日付费roi：">
          <span>
            {{ form.delivery_setting.first_roi_goal }}
          </span>
        </LabelRow>
      </template>

      <template v-else>
        <LabelRow label="目标出价：" v-if="projectBidVisible">
          <span v-if="form.delivery_setting.bid_value_type === BID_VALUE_TYPE.FIXED">{{ form.delivery_setting.cpa_bid }}</span>
          <span v-if="form.delivery_setting.bid_value_type === BID_VALUE_TYPE.RANGE">
            {{ bidRangeNumber }}
          </span>
        </LabelRow>
      </template>

      <!-- adDeepBidVisible 这里用作是否隐藏深度目标出价 -->
      <LabelRow label="深度目标出价：" v-if="projectBidVisible && adDeepBidVisible">
        <span v-if="form.delivery_setting.roi_bid_value_type === BID_VALUE_TYPE.FIXED">{{ form.delivery_setting.roi_goal }}</span>
        <span v-if="form.delivery_setting.roi_bid_value_type === BID_VALUE_TYPE.RANGE">
          {{ roiBidRangeNumber }}
        </span>
      </LabelRow>
    </template>
    <div class="empty" v-else>请配置基础信息</div>
  </div>
</template>

<script setup>
import { toRef, computed, inject } from 'vue'
import { PLATFORM_LIST } from '@/common/js/constants.js'
import {
  LANDING_TYPE_LIST,
  APP_PROMOTION_TYPE_LIST,
  DELIVERY_MODE_LIST,
  DELIVERY_TYPE_LIST,
  MARKETING_GOAL_LIST,
  AUDIENCE_EXTEND_LIST,
  SCHEDULE_TYPE,
  SCHEDULE_TIME_TYPE,
  BID_TYPE,
  BID_TYPE_LIST,
  BID_VALUE_TYPE,
  LANDING_TYPE,
  BUDGET_MODE,
  EXTERNAL_ACTION_LIST,
  DEEP_BID_TYPE,
  DEEP_BID_TYPE_LIST,
  DEEP_EXTERNAL_ACTION_LIST,
  DELIVERY_MODE,
  PROJECT_AUDIENCE_TYPE
} from '../../consts/index.js'
import Divider from '../layout/title-divider.vue'
import LabelRow from '../layout/label-row.vue'
import ReadableWeekdays from '@/views/edit/kuaishou/components/time-range/weekdaysTextTransformer.vue'
import { useOptimizeGoalRelative } from '../../hooks/useOptimizeGoal.js'

// eslint-disable-next-line
const props = defineProps({
  form: Object
})
const form = toRef(props, 'form')
const { isV3 } = inject('bytedanceVersion', { isV3: computed(() => false) })

const starTaskNames = computed(() => form.value.star_task?.star_task_name || '')
const audienceTypeLabel = computed(() => (form.value.audience_type === PROJECT_AUDIENCE_TYPE.CUSTOM ? '自定义' : '不限'))

const { isAll, isSearch, isDuration, isBlueFlowEnable, isFirstRoiGoal, adDeepBidVisible, projectBidVisible } = useOptimizeGoalRelative(form)

const bidRangeNumber = computed(() => {
  const [cpa_bid_min, cpa_bid_max] = form.value.delivery_setting?.bid_num_range || []
  if (!cpa_bid_min || !cpa_bid_max) return ''
  return `${cpa_bid_min}~${cpa_bid_max}`
})

const roiBidRangeNumber = computed(() => {
  const [roi_bid_min, roi_bid_max] = form.value.delivery_setting?.roi_bid_num_range || []
  if (!roi_bid_min || !roi_bid_max) return ''
  return `${roi_bid_min}~${roi_bid_max}`
})
</script>

<style lang="scss" scoped>
.preview-box {
  height: 720px;
  overflow: auto;
  padding: 10px;
  .empty {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
